"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CrudService_1 = __importDefault(require("../../Core/CrudService"));
var CustomersService = /** @class */ (function () {
    function CustomersService(session) {
        this.service = new CrudService_1.default(session, 'customers');
    }
    CustomersService.prototype.load = function (id, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.get(id, commonOptions)];
            });
        });
    };
    CustomersService.prototype.loadAll = function (params, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = params && {
                    pgver: 2,
                    cursor: params.cursor,
                    page_action: params.pageAction,
                    query: params.query
                };
                return [2 /*return*/, this.service.getAll(request, commonOptions)];
            });
        });
    };
    CustomersService.prototype.loadMany = function (customerIds, commonOptions) {
        return this.service.routeGenerator
            .get("/".concat(this.service.entityName, "/batch/"))
            .withQueryString({ ids: customerIds.join(',') })
            .withExtractor(function (response) { return response.items; })
            .setException("Failed to loadMany for ids ".concat(customerIds))
            .withCommonOptions(commonOptions)
            .invoke();
    };
    CustomersService.prototype.find = function (params, commonOptions) {
        return this.service.routeGenerator
            .get("/".concat(this.service.entityName, "/find/"))
            .withQueryString({ phonenum: params.phone, name: params.name, external_id: params.external_id })
            .withExtractor(function (response) { return response.results; })
            .setException("Failed to find for params ".concat(JSON.stringify(params)))
            .withCommonOptions(commonOptions)
            .invoke();
    };
    CustomersService.prototype.getTasks = function (id, page, commonOptions) {
        return this.service.routeGenerator
            .get("/".concat(this.service.entityName, "/{:id}/tasks/"))
            .withRouteParams({ id: id })
            .withQueryString({ page: page })
            .setException("Failed to getTasks for id ".concat(id, ", page ").concat(page))
            .withCommonOptions(commonOptions)
            .invoke();
    };
    CustomersService.prototype.getTotalTasks = function (id, commonOptions) {
        return this.service.routeGenerator
            .get("/".concat(this.service.entityName, "/{:id}/tasks/count"))
            .withRouteParams({ id: id })
            .withExtractor(function (response) { return response.count; })
            .setException("Failed to getTotalTasks for id ".concat(id))
            .withCommonOptions(commonOptions)
            .invoke();
    };
    CustomersService.prototype.update = function (customer, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(customer.id, customer, commonOptions)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.customer];
                }
            });
        });
    };
    CustomersService.prototype.create = function (customer, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(customer, commonOptions)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.customer];
                }
            });
        });
    };
    return CustomersService;
}());
exports.default = CustomersService;
//# sourceMappingURL=customers-service.js.map